import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";
import { DateTime } from "luxon";

// type actions = CurrentMentorsActions & LiveSwitchAction
export default function scheduleSlotsReducer(
    state = initialState.scheduleSlots,
    action: CurrentMentorsActions | LiveSwitchAction
): DateTime[] | null {
    switch (action.type) {
        case types.GET_SCHEDULESLOTS_SUCCESS_SILENT:
            var rtn = (state ?? []).filter((d) => d < action.startDate && d > action.endDate);
            return rtn.concat(action.slots);
        default:
            return state;
    }
}
